"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const AlignLeft = (props) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "icon icon-tabler icons-tabler-outline icon-tabler-align-left", ...props },
    React.createElement("path", { d: "M0 0h24v24H0z", stroke: "none" }),
    React.createElement("path", { d: "M4 6h16M4 12h10M4 18h14" }));
exports.default = AlignLeft;
